/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconCheckFilled from 'DesignSystem/Svgs/TysiaIconCheckFilled/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/PayerInfo/Installment/Content/Installments/Completed/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsGreen800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.800'
        })
  return (<React.Fragment
>
<TysiaIconCheckFilled
  viewPath={`${viewPath}/TysiaIconCheckFilled`}
 marginLeft={dtSpaceXxs}
 width={12}
 height={12}
 fill2={dtColorsGreen800}
/>
{children}
</React.Fragment>)
}